export default function formatImageUrl(
  url: string,
  filename: string,
  locale: string = "en",
) {
  if (!url) return url;

  const urlObj = new URL(url);
  const path = urlObj.pathname;
  const lastSlashIndex = path.lastIndexOf("/");
  const originalFilename = path.substring(lastSlashIndex + 1);
  const resolvedFilename =
    typeof filename === "string" ? filename : filename?.[locale];
  const newFilename = resolvedFilename
    ? `${originalFilename}/${resolvedFilename}`
    : originalFilename;
  urlObj.pathname = path.substring(0, lastSlashIndex + 1) + newFilename;

  return urlObj?.toString();
}
